
//  export default tokens

export default {
  Link: {
    highlight: {
      textColor: '#16a7cd',
      typography: {
        fontFamily: '',
        fontWeight: 500,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'none',
        type: 'typography',
      },
      cursor: 'pointer',
    },
    highlight_hover: {
      textColor: '#1286a4',
      typography: {
        fontFamily: '',
        fontWeight: 500,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'none',
        type: 'typography',
      },
    },
    highlight_disabled: {
      typography: {
        fontFamily: '',
        fontWeight: 500,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'none',
        type: 'typography',
      },
      textColor: '#a0a0a0',
      cursor: 'default',
    },
    default: {
      textColor: '#252525',
      typography: {
        fontFamily: '',
        fontWeight: 500,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'underline',
        type: 'typography',
      },
      cursor: 'pointer',
    },
    default_hover: {
      textColor: '#1286a4',
      typography: {
        fontFamily: '',
        fontWeight: 500,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'underline',
        type: 'typography',
      },
    },
    default_disabled: {
      typography: {
        fontFamily: '',
        fontWeight: 500,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'none',
        type: 'typography',
      },
      textColor: '#a0a0a0',
      cursor: 'default',
    },
    extralight: {
      textColor: '#7c7c7c',
      typography: {
        fontFamily: '',
        fontWeight: 400,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'underline',
        type: 'typography',
      },
      cursor: 'pointer',
    },
    extralight_hover: {
      textColor: '#1286a4',
      typography: {
        fontFamily: '',
        fontWeight: 400,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'underline',
        type: 'typography',
      },
    },
    extralight_disabled: {
      typography: {
        fontFamily: '',
        fontWeight: 400,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'none',
        type: 'typography',
      },
      textColor: '#a0a0a0',
      cursor: 'default',
    },
    danger: {
      textColor: '#fa4747',
      typography: {
        fontWeight: 500,
        textDecoration: 'underline',
        type: 'typography',
      },
      cursor: 'pointer',
    },
    danger_hover: {
      textColor: '#fa4747',
      typography: {
        fontWeight: 500,
        textDecoration: 'none',
        type: 'typography',
      },
    },
    danger_disabled: {
      textColor: '#a0a0a0',
      typography: {
        fontWeight: 500,
        textDecoration: 'none',
        type: 'typography',
      },
      cursor: 'default',
    },
    defaultNegative: {
      textColor: '#ffffff',
      typography: {
        fontFamily: '',
        fontWeight: 500,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'underline',
        type: 'typography',
      },
      cursor: 'pointer',
    },
    defaultNegative_hover: {
      textColor: '#16a7cd',
      typography: {
        fontFamily: '',
        fontWeight: 500,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'underline',
        type: 'typography',
      },
    },
    defaultNegative_disabled: {
      typography: {
        fontFamily: '',
        fontWeight: 500,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'none',
        type: 'typography',
      },
      textColor: '#a0a0a0',
    },
    extralightNegative: {
      textColor: '#cbcbcb',
      typography: {
        fontFamily: '',
        fontWeight: 400,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'underline',
        type: 'typography',
      },
      cursor: 'pointer',
    },
    extralightNegative_hover: {
      textColor: '#cbcbcb',
      typography: {
        fontFamily: '',
        fontWeight: 400,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'underline',
        type: 'typography',
      },
    },
    extralightNegative_disabled: {
      typography: {
        fontFamily: '',
        fontWeight: 400,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '',
        textDecoration: 'none',
        type: 'typography',
      },
      textColor: '#a0a0a0',
      cursor: 'default',
    },
    defautNegative_disabled: { cursor: 'default' },
  },
  Button: {
    primary: {
      borderRadius: '4px',
      backgroundColor: '#16a7cd',
      textColor: '#ffffff',
      typography: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '0.03em',
        textDecoration: 'none',
        textCase: 'uppercase',
        type: 'typography',
      },
      textAlign: 'center',
      outline: 'none',
      cursor: 'pointer',
      borderWidth: '0px',
      borderColor: 'transparent',
    },
    primary_hover: {
      backgroundColor: '#1286a4',
      borderColor: 'transparent',
      textColor: '#ffffff',
    },
    primary_disabled: {
      backgroundColor: '#aaaaaa',
      cursor: 'default',
      borderColor: 'transparent',
      textColor: '#ffffff',
    },
    size: {
      medium: {
        typography: {
          fontFamily: '',
          fontWeight: '',
          lineHeight: '1.3em',
          fontSize: '13px',
          letterSpacing: '',
          textDecoration: '',
          textCase: '',
          type: 'typography',
        },
        height: '36px',
        paddingLeft: '16px',
        paddingRight: '16px',
        paddingTop: 0,
        paddingBottom: 0,
        width: 'auto',
        minWidth: 'auto',
      },
      small: {
        typography: {
          fontFamily: '',
          fontWeight: '',
          lineHeight: '1.3em',
          fontSize: '13px',
          letterSpacing: '',
          textDecoration: '',
          textCase: '',
          type: 'typography',
        },
        height: '28px',
        paddingLeft: '16px',
        paddingRight: '16px',
        paddingTop: 0,
        paddingBottom: 0,
        width: 'auto',
        minWidth: '28px',
      },
      large: {
        typography: {
          fontFamily: '',
          fontWeight: '',
          lineHeight: '1.3em',
          fontSize: '16px',
          letterSpacing: '',
          textDecoration: '',
          textCase: '',
          type: 'typography',
        },
        height: '40px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: 0,
        paddingBottom: 0,
        width: 'auto',
        minWidth: 'auto',
      },
    },
    secondary: {
      textColor: '#16a7cd',
      borderColor: '#16a7cd',
      borderRadius: '4px',
      borderWidth: '1px',
      typography: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '0.03em',
        textDecoration: 'none',
        textCase: 'uppercase',
        type: 'typography',
      },
      textAlign: 'center',
      outline: 'none',
      cursor: 'pointer',
      backgroundColor: 'transparent',
    },
    neutral: {
      borderRadius: '4px',
      textColor: '#252525',
      borderColor: '#252525',
      borderWidth: '1px',
      typography: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '0.03em',
        textDecoration: 'none',
        textCase: 'uppercase',
        type: 'typography',
      },
      textAlign: 'center',
      outline: 'none',
      cursor: 'pointer',
      backgroundColor: 'transparent',
    },
    danger: {
      borderRadius: '4px',
      borderWidth: '1px',
      textColor: '#c83939',
      borderColor: '#c83939',
      typography: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '0.03em',
        textDecoration: 'none',
        textCase: 'uppercase',
        type: 'typography',
      },
      textAlign: 'center',
      outline: 'none',
      cursor: 'pointer',
      backgroundColor: 'transparent',
    },
    negative: {
      borderRadius: '4px',
      textColor: '#ffffff',
      borderColor: '#ffffff',
      typography: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        lineHeight: '',
        fontSize: '',
        letterSpacing: '0.03em',
        textDecoration: 'none',
        textCase: 'uppercase',
        type: 'typography',
      },
      textAlign: 'center',
      outline: 'none',
      cursor: 'pointer',
      borderWidth: '1px',
      backgroundColor: 'transparent',
    },
    secondary_hover: {
      textColor: '#1286a4',
      borderColor: '#1286a4',
      backgroundColor: 'transparent',
    },
    secondary_disabled: {
      textColor: '#aaaaaa',
      borderColor: '#aaaaaa',
      cursor: 'default',
      backgroundColor: 'transparent',
    },
    neutral_disabled: {
      textColor: '#aaaaaa',
      borderColor: '#aaaaaa',
      cursor: 'default',
      backgroundColor: 'transparent',
    },
    danger_hover: {
      textColor: '#962b2b',
      borderColor: '#962b2b',
      backgroundColor: 'transparent',
    },
    danger_disabled: {
      textColor: '#aaaaaa',
      borderColor: '#aaaaaa',
      cursor: 'default',
      backgroundColor: 'transparent',
    },
    negative_hover: {
      textColor: '#ffffff',
      borderColor: '#ffffff',
      backgroundColor: '#ffffff26',
    },
    negative_disabled: {
      cursor: 'default',
      textColor: '#aaaaaa',
      borderColor: '#aaaaaa',
      backgroundColor: 'transparent',
    },
    neutral_hover: {
      textColor: '#252525',
      borderColor: '#252525',
      backgroundColor: 'transparent',
    },
  },
  colors: {
    greyscale: {
      white: '#ffffff',
      alabaster: '#f7f7f7',
      wildSand: '#f5f5f5',
      gallery: '#eeeeee',
      mercury01: '#e9e9e9',
      mercury02: '#e4e4e4',
      athensGray: '#e6e9ec',
      geyser: '#d5dadf',
      alto: '#d3d3d3',
      silver01: '#cbcbcb',
      silver02: '#b9b9b9',
      bombay: '#b5b9be',
      silverChalice01: '#aaaaaa',
      silverChalice03: '#a0a0a0',
      gray: '#838383',
      boulder: '#7c7c7c',
      doveGray: '#666666',
      tundora01: '#464646',
      tundora02: '#4c4c4c',
      mineShaft02: '#2c2c2c',
      mineShaft03: '#252525',
      black: '#000000',
      transparent: 'transparent',
    },
    blue: {
      iceberg: '#cfeaf1',
      pictonBlue: '#3dc6f5',
      java: '#16a7cd',
      blueChill: '#1286a4',
    },
    green: { teaGreen: '#d8f4c5', mantis: '#8acf61', sushi: '#68bc37' },
    teal: { swansDown: '#d2eee0', emerald: '#4bc88c', oceanGreen: '#39ba7c' },
    yellow: {
      champagne: '#faeecb',
      mustard: '#ffd754',
      amber: '#ffc400',
      sun: '#f8b309',
    },
    red: {
      azalea: '#f9d4d4',
      vividTangerine: '#ff8d84',
      persimmon: '#ff6458',
      sunsetOrange: '#fa4747',
      flushMahogany: '#c83939',
      stiletto: '#962b2b',
    },
    orange: { negroni: '#ffe3bf', pizazz: '#ff9000' },
    shadow: { mineShaft03: '#25252526' },
    gradient: {
      onLight: 'linear-gradient(90deg, #f0f0f0 0%, #f6f6f6 100%)',
      onGray: 'linear-gradient(90deg, #E8E8E8 0%, #ECECEC 100%)',
      onDark: 'linear-gradient(90deg, #303030 0%, #353535 100%)',
    },
  },
  Provashadows: {
    boxshadow: {
      default: {
        x: 0,
        y: 3,
        blur: 6,
        spread: 0,
        color: '#25252526',
        type: 'boxShadow',
      },
    },
  },
  fontFamily: {
    roboto: 'Roboto',
    robotoCondensed: 'Roboto Condensed',
    robotoItalic: 'Roboto Italic',
  },
  fontSize: {
    xxsmall: '12px',
    xsmall: '13px',
    small: '14px',
    default: '15px',
    medium: '16px',
    large: '18px',
    xlarge: '22px',
    xxlarge: '28px',
  },
  fontWeight: { default: 400, medium: 500 },
  lineHeight: { default: '1.3em', small: '1.2em' },
  letterSpacing: { small: '0.02em', default: '0.03em', large: '0.04em' },
  textDecoration: { default: 'none', underline: 'underline' },
  fontStyle: { default: 'normal', italic: 'italic' },
  titles: {
    xl: {
      fontFamily: 'Roboto',
      fontWeight: 400,
      lineHeight: '1.2em',
      fontSize: '28px',
      letterSpacing: '0.02em',
      textDecoration: 'none',
      textCase: 'none',
      type: 'typography',
    },
    large: {
      fontFamily: 'Roboto',
      fontWeight: 400,
      lineHeight: '1.2em',
      fontSize: '22px',
      letterSpacing: '0.04em',
      textDecoration: 'none',
      textCase: 'none',
      type: 'typography',
    },
    medium: {
      fontFamily: 'Roboto',
      fontWeight: 400,
      lineHeight: '1.2em',
      fontSize: '18px',
      letterSpacing: '0.04em',
      textDecoration: 'none',
      textCase: 'none',
      type: 'typography',
    },
    small: {
      fontFamily: 'Roboto',
      fontWeight: 500,
      lineHeight: '1.2em',
      fontSize: '15px',
      letterSpacing: '0.03em',
      textDecoration: 'none',
      textCase: 'none',
      type: 'typography',
    },
    modali: {
      fontFamily: 'Roboto',
      fontWeight: 500,
      lineHeight: '1.2em',
      fontSize: '22px',
      letterSpacing: '0.03em',
      textDecoration: 'none',
      textCase: 'none',
      type: 'typography',
    },
  },
  paragraphs: {
    standard: {
      fontFamily: 'Roboto',
      fontWeight: 400,
      lineHeight: '1.3em',
      fontSize: '15px',
      letterSpacing: '0.03em',
      textDecoration: 'none',
      textCase: 'none',
      type: 'typography',
    },
    grassetto: {
      fontFamily: 'Roboto',
      fontWeight: 500,
      lineHeight: '1.3em',
      fontSize: '15px',
      letterSpacing: '0.03em',
      textCase: 'none',
      textDecoration: 'none',
      type: 'typography',
    },
    italic: {
      fontFamily: 'Roboto Italic',
      fontWeight: 400,
      lineHeight: '1.3em',
      fontSize: '15px',
      letterSpacing: '0.03em',
      textCase: 'none',
      textDecoration: 'none',
      type: 'typography',
    },
    textLight: {
      fontFamily: 'Roboto',
      fontWeight: 400,
      lineHeight: '1.3em',
      fontSize: '15px',
      letterSpacing: '0.03em',
      textCase: 'none',
      textDecoration: 'none',
      type: 'typography',
    },
    textExtraLight: {
      fontFamily: 'Roboto',
      fontWeight: 400,
      lineHeight: '1.3em',
      fontSize: '15px',
      letterSpacing: '0.03em',
      textCase: 'none',
      textDecoration: 'none',
      type: 'typography',
    },
    note: {
      fontFamily: 'Roboto',
      fontWeight: 400,
      lineHeight: '1.3em',
      fontSize: '14px',
      letterSpacing: '0.03em',
      textCase: 'none',
      textDecoration: 'none',
      type: 'typography',
    },
    textSmall: {
      fontFamily: 'Roboto',
      fontWeight: 400,
      lineHeight: '1.3em',
      fontSize: '14px',
      letterSpacing: '0.03em',
      textCase: 'none',
      textDecoration: 'none',
      type: 'typography',
    },
    grassettoUnderline: {
      fontFamily: 'Roboto',
      fontWeight: 500,
      lineHeight: '1.3em',
      fontSize: '15px',
      letterSpacing: '0.03em',
      textDecoration: 'underline',
      textCase: 'none',
      type: 'typography',
    },
  },
  spacing: {
    d4: '2px',
    d2: '4px',
    default: '8px',
    x2: '16px',
    'x2,5': '20px',
    x3: '24px',
    x4: '32px',
    x5: '40px',
    zero: 0,
  },
  textCase: { default: 'none', uppercase: 'uppercase' },
  borderWidth: { default: '1px', zero: '0px' },
  borderRadius: { small: '4px' },
  cursor: { default: 'default', pointer: 'pointer' },
  width: { auto: 'auto' },
  outline: { none: 'none' },
  textAlign: { center: 'center' },
  minWidth: { auto: 'auto' },
  additional: {
    prova: { zIndex: '10', fontFamily: "'Roboto', arial, sans-serif" },
  },
  InputTextIcon: {
    borderRadius: { icon: '4px 0 0 4px', input: '0 4px 4px 0' },
    borderWidth: '1px',
    borderColor: '#d5dadf',
    borderColor_disabled: '#b5b9be',
    borderColor_danger: '#fa4747',
  },
}
